import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

const initialState = {
    userDetails: {},
    isInitialPageLoad: true,
    successMessage: false,
};

export const UserSlice = createSlice({
    name: "userDetails",
    initialState,
    reducers: {
        updateUser: (state, action: PayloadAction<any>) => {
            state.userDetails = { ...action.payload };
        },
        updatePageLoad: (state, action: PayloadAction<any>) => {
            state.isInitialPageLoad = action.payload
        },
        hideSuccessMessage: (state, action: PayloadAction<any>) => {
            state.successMessage = action.payload
        },
    },
});

export const { updateUser, updatePageLoad, hideSuccessMessage } = UserSlice.actions;
export const UserState = (state: RootState) => state.userDetails;
export default UserSlice.reducer;
